// extracted by mini-css-extract-plugin
module.exports = {"grid":"search_grid__5DxuO","recommendList":"search_recommendList__2htPx","banner":"search_banner__diKE9","list4":"search_list4__3TR50"};